<template>
  <span class="rating-stars">
    <StarIcon
      v-for="i in starCount"
      :key="i"
      :size="size"
      class="rating-stars__icon"
    />
  </span>
</template>

<script lang="ts">
import StarIcon from '@/core/components/shared/icons/Star.icon.vue'

export default defineNuxtComponent({
  components: {
    StarIcon,
  },
  props: {
    amount: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 18,
    },
  },
  setup(props) {
    const starCount = Math.floor(props.amount)
    return { starCount }
  },
})
</script>

<style lang="scss" scoped>
.rating-stars {
  @apply flex;
  @apply flex-row;
  @apply items-center;

  @screen lg {
    &__icon {
      @apply ml-1;
    }
  }
}
</style>
